import { Types } from '../../../actions/dashboards'
import { Metrics } from '../../../constants/Dashboards'
import buildAsyncStatReducer from './asyncStatReducer'

/**
 * Media Latest
 */
const mediaLatest = buildAsyncStatReducer({
    key: Metrics.MEDIA_LATEST,
    types: {
        request: Types.DASHBOARD_MEDIA_SCHEDULED_NEXT.request,
        success: Types.DASHBOARD_MEDIA_SCHEDULED_NEXT.success,
        failure: Types.DASHBOARD_MEDIA_LATEST.failure,
    },
    transform: (state, { payload }) => {
        const { id, name } = payload[0] || {}
        return { id, name }
    },
})

/**
 * Media next scheduled
 */
const mediaScheduledNext = buildAsyncStatReducer({
    key: Metrics.MEDIA_SCHEDULED_NEXT,
    types: {
        request: Types.DASHBOARD_MEDIA_SCHEDULED_NEXT.request,
        success: Types.DASHBOARD_MEDIA_SCHEDULED_NEXT.success,
        failure: Types.DASHBOARD_MEDIA_SCHEDULED_NEXT.failure,
    },
    transform: (state, { payload }) => {
        const { id, name } = payload[0] || {}
        return { id, name }
    },
})

/**
 * Content last dowloaded by CDD servers
 */
 const lastDownloadCDDS = buildAsyncStatReducer({
    key: Metrics.CDD_LAST_DOWNLOAD,
    types: {
        request: Types.DASHBOARD_CDD_LAST_DOWNLOAD.request,
        success: Types.DASHBOARD_CDD_LAST_DOWNLOAD.success,
        failure: Types.DASHBOARD_CDD_LAST_DOWNLOAD.failure,
    },
    transform: (state, { payload }) => {
        const { id, name } = payload[0] || {}
        return { id, name }
    },
})

const devicesReducers = [mediaLatest, mediaScheduledNext, lastDownloadCDDS]

export default devicesReducers
